/* banner.tsx generated by @compiled/babel-plugin v0.32.2 */
import "./banner.compiled.css";
import { ax, ix } from "@compiled/react/runtime";
import React, { useContext } from 'react';
import { useSkipLink } from '../../context/skip-links/skip-links-context';
import { bannerMountedVar, localSlotLayers, UNSAFE_bannerVar } from './constants';
import { DangerouslyHoistSlotSizes } from './hoist-slot-sizes-context';
import { DangerouslyHoistCssVarToDocumentRoot, HoistCssVarToLocalGrid } from './hoist-utils';
import { usePrefixedUID } from './use-prefixed-id';
var styles = {
  root: "_nd5ldkfm _4t3iutvi _152tidpf _kqsw1if8 _1pbyegat _1reo15vq _18m915vq"
};
export function Banner(_ref) {
  var children = _ref.children,
    xcss = _ref.xcss,
    _ref$UNSAFE_height = _ref.UNSAFE_height,
    UNSAFE_height = _ref$UNSAFE_height === void 0 ? 64 : _ref$UNSAFE_height,
    _ref$label = _ref.label,
    label = _ref$label === void 0 ? 'Banner' : _ref$label,
    testId = _ref.testId,
    id = _ref.id;
  var dangerouslyHoistSlotSizes = useContext(DangerouslyHoistSlotSizes);
  var UID = usePrefixedUID();
  var CID = id ? id : UID;
  useSkipLink(CID, label);
  return /*#__PURE__*/React.createElement("div", {
    id: CID,
    role: "banner",
    "data-layout-slot": true,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
    className: ax([styles.root, xcss]),
    "data-testid": testId
  }, /*#__PURE__*/React.createElement(HoistCssVarToLocalGrid, {
    variableName: bannerMountedVar,
    value: UNSAFE_height
  }), dangerouslyHoistSlotSizes &&
  /*#__PURE__*/
  // ------ START UNSAFE STYLES ------
  // These styles are only needed for the UNSAFE legacy use case for Jira + Confluence.
  // When they aren't needed anymore we can delete them wholesale.
  React.createElement(DangerouslyHoistCssVarToDocumentRoot, {
    variableName: UNSAFE_bannerVar,
    value: UNSAFE_height
  })
  // ------ END UNSAFE STYLES ------
  , children);
}